// @ts-expect-error no types
import BaseDialog from 'customer-data-ui-utilities/dialog/BaseDialog';
import I18n from 'I18n';
import GoVideoContainer from './GoVideoContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const GoVideoDialog = props => {
  return /*#__PURE__*/_jsx(BaseDialog, {
    className: "GoVideoDialog p-bottom-10",
    bodyClassName: "display-flex align-center justify-center",
    onReject: props.onClose,
    showCancelButton: false,
    showConfirmButton: false,
    title: I18n.text('draftPlugins.goVideoModal.title'),
    width: 625,
    size: "short",
    children: /*#__PURE__*/_jsx(GoVideoContainer, {
      isInServiceHub: props.isInServiceHub
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function | undefined' is not assignable to t... Remove this comment to see the full error message
      ,
      onChange: props.onChange
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type '(...arg... Remove this comment to see the full error message
      ,
      onClose: props.onClose
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function | undefined' is not assignable to t... Remove this comment to see the full error message
      ,
      onConfirm: props.onConfirm
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'object |... Remove this comment to see the full error message
      ,
      trackingHandlers: props.trackingHandlers,
      recipientEmail: props.recipientEmail,
      isInlineVideo: props.isInlineVideo,
      showTitleCheckBox: props.showTitleCheckBox
    })
  });
};
export default GoVideoDialog;